import { FC } from "react";

import clsx from "clsx";

import { CourseStatuses } from "../../../model";

import st from "./StatusTag.module.scss";

const TITLE_BY_STATUS = {
  [ CourseStatuses.NotStarted ]: "Не начато",
  [ CourseStatuses.InProgress ]: "В процессе",
  [ CourseStatuses.Passed ]: "Завершено",
  [ CourseStatuses.New ]: "New",
  [ CourseStatuses.Required ]: "Required",
  [ CourseStatuses.Unknown ]: "Unknown",
};

type Props = {
  status: CourseStatuses,
  className?: string,
};

export const StatusTag: FC<Props> = ({
  status,
  className,
}) => {
  return (
    <span
      className={
        clsx(
          st.tag,
          st[ status ],
          className,
        )
      }
    >
      {TITLE_BY_STATUS[ status ]}
    </span>
  );
};
